module.exports = __webpack_public_path__ + "img/oli.f4a0ab13.png";